import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_OCTOPUS_AA_AUGMENTED_SIGN_ASK_CONFIG = createFcmDetails(
	'octopus_aa_augmented_sign_ask_config',
	{
		owner: 'Site Platform',
		context: 'comms stack',
		description:
			'Template experiment config for aa_augmented_sign_ask message type. Leave the constraints empty [], to enable the experiment for all countries.',
		import: false,
		template: {
			name: '<experiment_name>',
			constraints: ['AR', 'AU', 'BR', 'CA', 'DE', 'ES', 'FR', 'GB', 'ID', 'IN', 'IT', 'JP', 'MX', 'TH', 'TR', 'US'],
		},
	},
);
